import PropTypes from 'prop-types'

const props = {
  inDialog: PropTypes.bool,
  renderPanel: PropTypes.func,
  formErrors: PropTypes.object,
  serverErrorMsg: PropTypes.string,
  validate: PropTypes.func,
  properties: PropTypes.object,
  isValidating: PropTypes.bool,
  customDetourHandler: PropTypes.func
}

export { props }
